import(/* webpackMode: "eager" */ "/builds/src/app/(events)/events/soopi/conversation/index/page.jsx");
